import { render, staticRenderFns } from "./MentorshipGroup.vue?vue&type=template&id=98a2a552"
import script from "./MentorshipGroup.vue?vue&type=script&lang=js"
export * from "./MentorshipGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports